'use strict';

export const DEFAULT_ROLES = {
  OWNER: 'owner',
  ADMIN: 'admin',
  POWER_USER: 'power_user',
  USER: 'user',
};

DEFAULT_ROLES.toList = () => ['owner', 'admin', 'power_user', 'user'];

DEFAULT_ROLES.toLinksList = () => [
  {id: 'owner', collection: '_roles'},
  {id: 'admin', collection: '_roles'},
  {id: 'power_user', collection: '_roles'},
  {id: 'user', collection: '_roles'},
];



// WEBPACK FOOTER //
// ./src/js/auth/enums/DEFAULT_ROLES.js